<template>
  <div class="commonfoot" :style="style">
    <v-commonFootStyleTwo
      v-if="styles_type === 'styles_two'"
      :default_footer_items="default_footer_items"
      :title="title"
      :show_payment_icons="show_payment_icons"
      :langs="langs"
      :langs_meta="langs_meta"
      :enabled="enabled"
    ></v-commonFootStyleTwo>
    <div class="container text-sm-left text-center foot-style-one" v-else>
      <div class="row">
        <div :class="social_medias_on ? 'col-sm-3' : 'col-sm-4'" v-if="footleftmenu.length">
          <ul>
            <li v-for="item in footleftmenu" :key="'left' + item.ID">
              <a class="page_text_font" :href="item.path || item.url">{{ item.title }}</a>
            </li>
          </ul>
        </div>
        <div :class="social_medias_on ? 'col-sm-3' : 'col-sm-4'" v-if="footleftmenu.length">
          <ul v-if="footmenu.length >= 6">
            <li v-for="item in footcentermenu" :key="'center' + item.ID">
              <a class="page_text_font" :href="item.path || item.url">{{ item.title }}</a>
            </li>
          </ul>
        </div>
        <div
          :class="[!footmenu.length ? 'col-sm-4 offset-sm-4' : 'col-sm-2', 'text-center text-sm-left']"
          v-if="social_medias_on"
        >
          <ul class="d-inline-block text-left">
            <template v-for="(item, index) in social_medias">
              <li v-if="item && item.open_url" :key="'social_medias' + index">
                <a class="page_text_font" :href="item.open_url" target="_blank">
                  <span :class="`iconfont icon-cm-${index === 'instagram' ? index + '-fill' : index}`"></span>
                  {{ index }}</a
                >
              </li>
            </template>
          </ul>
        </div>
        <div
          class="commonfootright text-sm-right text-center col-12"
          :class="[footleftmenu.length || social_medias_on ? ' col-sm-4' : '']"
        >
          <p><a class="page_text_font" href="/policies/ip" style="color: #212529">DMCA report</a></p>
          <p class="page_text_font">© {{ new Date().getFullYear() }},{{ title }}</p>
          <v-selectlang :langs_meta="langs_meta"></v-selectlang>
          <v-payicon
            v-if="show_payment_icons"
            :style="{ 'margin-top': enabled ? '0' : '15px', 'margin-right': '-15px' }"
          ></v-payicon>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import vCommonFootStyleTwo from './commonFootStyleTwo.vue'
export default {
  props: ['title', 'footmenu', 'show_payment_icons', 'langs', 'enabled', 'langs_meta', 'default_footer_items'],
  components: {
    vCommonFootStyleTwo,
  },
  data() {
    return {
      footleftmenu: [],
      footcentermenu: [],
    }
  },
  computed: {
    style() {
      let style = {}
      if (this.styles_type === 'styles_two') {
        let footer = this.$store.state.options?.theme?.modules?.footer
        let { background_color, text_color } = footer || {}
        if (background_color) {
          style['--default-foot-bg-color'] = background_color
        }
        if (text_color) {
          style['--default-foot-tx-color'] = text_color
        }
      }
      return style;
    },
    ...mapState({
      social_medias: ({ options }) => options?.theme?.modules?.footer?.social_medias,
      styles_type: ({ options }) => options?.theme?.modules?.footer?.styles_type,
    }),
    social_medias_on() {
      let onOff = false
      if (!this.social_medias || !Object.prototype.toString.call(this.social_medias) === '[object Object]') return onOff
      for (const key in this.social_medias) {
        if (
          Object.hasOwnProperty.call(this.social_medias, key) &&
          this.social_medias[key] &&
          this.social_medias[key]['open_url']
        ) {
          onOff = true
        }
      }
      return onOff
    },
  },
  mounted() {
    console.log(this.default_footer_items, 'default_footer_itemsdefault_footer_items')
    let menu_count = this.footmenu.length
    if (menu_count > 5) {
      this.footcentermenu = this.footmenu.slice(Math.ceil(menu_count / 2))
      this.footleftmenu = this.footmenu.slice(0, Math.ceil(menu_count / 2))
    } else {
      this.footleftmenu = this.footmenu
    }
  },
}
</script>
<style scoped lang='scss'>
.commonfoot {
  //padding-top: 90px;
  margin-top: 40px;
  padding-top: 40px;
  text-align: center;
  background-color: var(--default-foot-bg-color,white);
  hr {
    height: 1px;
    margin: 0 auto 40px;
    display: block;
  }
  ul {
    padding: 0;
    li {
      list-style: none;
    }
  }
  .foot-style-one {
    padding: 0 0 30px 0;
    .row {
      margin: 0;
      justify-content: space-between;
      ul {
        margin: 0;
        li {
          margin-bottom: 4.5px;
          a {
            font-size: 16px;
            text-decoration: none;
            color: #000;
          }
        }
      }
    }

    p {
      padding: 0;
      margin: 0;
    }
  }
}
@media screen and(max-width: 768px) {
  .commonfoot {
    margin-top: 40px;
    hr {
      margin: 0 auto 20px;
    }
  }
}
</style>